import { useLocation } from 'react-router-dom';
import { CopilotPanel } from './CopilotPanel';

/** Mapeia pathname → contexto de página para sugestões contextuais */
function getPageContext(pathname: string) {
  if (pathname.startsWith('/app/contatos'))   return { page: 'contacts' };
  if (pathname.startsWith('/app/campanhas'))  return { page: 'campaigns' };
  if (pathname.startsWith('/app/agenda'))     return { page: 'events' };
  return { page: 'dashboard' };
}

export function CopilotPage() {
  const location = useLocation();
  const context  = getPageContext(location.pathname);

  return (
    <div className="flex flex-col gap-6 px-4 sm:px-6 py-6 max-w-3xl mx-auto w-full">
      <div>
        <h1 className="font-display text-2xl font-bold text-ink">Lumen</h1>
        <p className="text-sm text-ink-muted mt-1">
          Assistente inteligente com acesso à sua base de dados em tempo real.
        </p>
      </div>
      <CopilotPanel context={context} />
    </div>
  );
}
